<template>

    <div class="container">

        <app-head title="System" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('System') }}</h1>
        </div>

        <div class="card mb-4">
            <div class="card-header p-3 bg-secondary text-light">
                {{ __('Database') }}
            </div>
            <div class="table-responsive">
                <table class="table">
                    <tbody>
                        <tr v-for="(val, key) in dbVars">
                            <th>{{ key }}</th>
                            <td class="text-break">{{ val }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="card mb-4">
            <div class="card-header p-3 bg-secondary text-light">
                {{ __('PHP') }}
            </div>
            <div class="table-responsive">
                <table class="table">
                    <tbody>
                        <tr v-for="(val, key) in phpVars">
                            <th>{{ key }}</th>
                            <td class="text-break">{{ val }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="card mb-4">
            <div class="card-header p-3 bg-secondary text-light">
                {{ __('Server') }}
            </div>
            <div class="table-responsive">
                <table class="table">
                    <tbody>
                        <tr v-for="(val, key) in serverVars">
                            <th>{{ key }}</th>
                            <td class="text-break">{{ val }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        props: [
            'dbVars',
            'phpVars',
            'serverVars',
        ]
    }
</script>